function toAmount(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function normalizeText(value) {
  return String(value || '').trim().toLowerCase();
}

function compareRows(a, b) {
  const codeA = String(a.code || '');
  const codeB = String(b.code || '');
  if (codeA && codeB) {
    return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
  }
  return String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' });
}

function buildLineKey(line) {
  const code = String(line?.code || '').trim();
  const name = normalizeText(line?.name);
  return code || name;
}

function sumRows(rows, amountKey) {
  return rows.reduce((total, row) => total + toAmount(row[amountKey]), 0);
}

const LABELS = {
  tr: {
    reportTitle: 'Nakit Akis Tablosu',
    statementName: 'IFRS Nakit Akis Tablosu',
    lineItem: 'Nakit Akisi Kalemi',
    noteRef: 'Dipnot Ref.',
    currentPeriod: 'Cari Donem',
    previousPeriod: 'Onceki Donem',
    noComparative: 'Karsilastirmali onceki donem verisi bulunamadi.',
    basisNote: 'Sunum, IAS 7 cizgisinde indirekt yontem bakisiyla faaliyet, yatirim ve finansman bolumleri halinde duzenlendi.',
    operatingSection: 'ISLETME FAALIYETLERI',
    investingSection: 'YATIRIM FAALIYETLERI',
    financingSection: 'FINANSMAN FAALIYETLERI',
    unclassifiedSection: 'DIGER / SINIFLANDIRILAMAYAN NAKIT AKISLARI',
    operatingCash: 'Isletme Faaliyetlerinden Nakit Akislari',
    investingCash: 'Yatirim Faaliyetlerinden Nakit Akislari',
    financingCash: 'Finansman Faaliyetlerinden Nakit Akislari',
    unclassifiedCash: 'Siniflandirilamayan Nakit Akislari',
    operatingNonCash: 'Nakit Etkisi Olmayan Isletme Duzeltmeleri',
    investingNonCash: 'Nakit Etkisi Olmayan Yatirim Duzeltmeleri',
    financingNonCash: 'Nakit Etkisi Olmayan Finansman Duzeltmeleri',
    unclassifiedNonCash: 'Nakit Etkisi Olmayan Diger Duzeltmeler',
    netOperating: 'ISLETME FAALIYETLERINDEN NET NAKIT',
    netInvesting: 'YATIRIM FAALIYETLERINDEN NET NAKIT',
    netFinancing: 'FINANSMAN FAALIYETLERINDEN NET NAKIT',
    netUnclassified: 'DIGER / SINIFLANDIRILAMAYAN NET NAKIT',
    totalSection: 'BOLUM TOPLAMI',
    netChange: 'NAKIT VE NAKIT BENZERLERINDE NET ARTIS / AZALIS',
    openingCash: 'DONEM BASI NAKIT VE NAKIT BENZERLERI',
    closingCash: 'DONEM SONU NAKIT VE NAKIT BENZERLERI'
  },
  en: {
    reportTitle: 'Statement of Cash Flows',
    statementName: 'IFRS Statement of Cash Flows',
    lineItem: 'Cash Flow Line Item',
    noteRef: 'Note Ref.',
    currentPeriod: 'Current Period',
    previousPeriod: 'Previous Period',
    noComparative: 'No comparative previous-period data was found.',
    basisNote: 'Presentation is structured into operating, investing and financing sections in an IAS 7-oriented indirect method view.',
    operatingSection: 'OPERATING ACTIVITIES',
    investingSection: 'INVESTING ACTIVITIES',
    financingSection: 'FINANCING ACTIVITIES',
    unclassifiedSection: 'OTHER / UNCLASSIFIED CASH FLOWS',
    operatingCash: 'Cash Flows from Operating Activities',
    investingCash: 'Cash Flows from Investing Activities',
    financingCash: 'Cash Flows from Financing Activities',
    unclassifiedCash: 'Unclassified Cash Flows',
    operatingNonCash: 'Non-cash Operating Adjustments',
    investingNonCash: 'Non-cash Investing Adjustments',
    financingNonCash: 'Non-cash Financing Adjustments',
    unclassifiedNonCash: 'Other Non-cash Adjustments',
    netOperating: 'NET CASH FROM OPERATING ACTIVITIES',
    netInvesting: 'NET CASH FROM INVESTING ACTIVITIES',
    netFinancing: 'NET CASH FROM FINANCING ACTIVITIES',
    netUnclassified: 'NET OTHER / UNCLASSIFIED CASH FLOWS',
    totalSection: 'SECTION TOTAL',
    netChange: 'NET INCREASE / DECREASE IN CASH AND CASH EQUIVALENTS',
    openingCash: 'CASH AND CASH EQUIVALENTS AT THE BEGINNING OF THE PERIOD',
    closingCash: 'CASH AND CASH EQUIVALENTS AT THE END OF THE PERIOD'
  }
};

const LINE_LABELS = {
  NET_PROFIT:       { tr: 'Donem Net Kari/Zarari',                en: 'Period Net Profit / Loss' },
  DEPRECIATION_ADJ: { tr: 'Amortisman Duzeltmesi',                en: 'Depreciation Adjustment' },
  WORKING_CAPITAL:  { tr: 'Calisma Sermayesi Degisimi',            en: 'Working Capital Change' },
  OPERATING:        { tr: 'Esas Faaliyetlerden Nakit Akisi',       en: 'Cash Flow from Operating Activities' },
  INVESTING:        { tr: 'Yatirim Faaliyetlerinden Nakit Akisi',  en: 'Cash Flow from Investing Activities' },
  FINANCING:        { tr: 'Finansman Faaliyetlerinden Nakit Akisi', en: 'Cash Flow from Financing Activities' }
};

const SECTION_CONFIG = [
  {
    key: 'OPERATING',
    titleKey: 'operatingSection',
    cashTitleKey: 'operatingCash',
    nonCashTitleKey: 'operatingNonCash',
    totalLabelKey: 'netOperating'
  },
  {
    key: 'INVESTING',
    titleKey: 'investingSection',
    cashTitleKey: 'investingCash',
    nonCashTitleKey: 'investingNonCash',
    totalLabelKey: 'netInvesting'
  },
  {
    key: 'FINANCING',
    titleKey: 'financingSection',
    cashTitleKey: 'financingCash',
    nonCashTitleKey: 'financingNonCash',
    totalLabelKey: 'netFinancing'
  },
  {
    key: 'UNCLASSIFIED',
    titleKey: 'unclassifiedSection',
    cashTitleKey: 'unclassifiedCash',
    nonCashTitleKey: 'unclassifiedNonCash',
    totalLabelKey: 'netUnclassified'
  }
];

function normalizeClassification(line) {
  const rawType = String(line?.accountType || '').trim().toUpperCase();
  if (rawType === 'OPERATING_NON_CASH') return { classification: 'OPERATING', nonCash: true };
  if (rawType === 'INVESTING_NON_CASH') return { classification: 'INVESTING', nonCash: true };
  if (rawType === 'FINANCING_NON_CASH') return { classification: 'FINANCING', nonCash: true };
  if (rawType === 'UNCLASSIFIED_NON_CASH') return { classification: 'UNCLASSIFIED', nonCash: true };
  if (rawType === 'OPERATING' || rawType === 'INVESTING' || rawType === 'FINANCING' || rawType === 'UNCLASSIFIED') {
    return { classification: rawType, nonCash: false };
  }

  const code = String(line?.code || '').trim().toUpperCase();
  if (code.endsWith('_NON_CASH')) {
    return { classification: code.replace(/_NON_CASH$/, ''), nonCash: true };
  }
  return { classification: code || 'UNCLASSIFIED', nonCash: false };
}

function combineLines(currentLines, previousLines) {
  const registry = new Map();

  currentLines.forEach((line) => {
    const key = buildLineKey(line);
    const bucket = normalizeClassification(line);
    if (!key) return;
    registry.set(key, {
      key,
      code: line.code || '',
      name: line.name || line.code || '-',
      noteRef: '',
      classification: bucket.classification,
      nonCash: bucket.nonCash,
      currentAmount: toAmount(line.amount),
      previousAmount: 0
    });
  });

  previousLines.forEach((line) => {
    const key = buildLineKey(line);
    const bucket = normalizeClassification(line);
    if (!key) return;
    const existing = registry.get(key);
    if (existing) {
      existing.previousAmount = toAmount(line.amount);
      return;
    }
    registry.set(key, {
      key,
      code: line.code || '',
      name: line.name || line.code || '-',
      noteRef: '',
      classification: bucket.classification,
      nonCash: bucket.nonCash,
      currentAmount: 0,
      previousAmount: toAmount(line.amount)
    });
  });

  return [...registry.values()].sort(compareRows);
}

function parseValidationMetrics(note) {
  const text = String(note || '');
  const extract = (label) => {
    const match = text.match(new RegExp(`${label}\\(([-0-9.,]+)\\)`, 'i'));
    if (!match) return 0;
    return toAmount(match[1].replace(',', '.'));
  };

  return {
    openingCash: extract('opening_cash'),
    netCashFlow: extract('net_cash_flow'),
    closingCash: extract('closing_cash')
  };
}

function buildGroup(key, title, rows, variant = 'detail') {
  return {
    key,
    title,
    rows,
    variant,
    currentTotal: sumRows(rows, 'currentAmount'),
    previousTotal: sumRows(rows, 'previousAmount')
  };
}

function buildSummaryGroup(key, title, currentTotal, previousTotal, variant = 'summary-strong') {
  return {
    key,
    title,
    rows: [],
    variant,
    currentTotal,
    previousTotal
  };
}

export function buildCashFlowPresentation({
  currentReport,
  previousReport,
  currentPeriodLabel,
  previousPeriodLabel,
  isTr
}) {
  const labels = isTr ? LABELS.tr : LABELS.en;
  const locale = isTr ? 'tr-TR' : 'en-US';
  const lang = isTr ? 'tr' : 'en';
  const combinedRows = combineLines(currentReport?.lines || [], previousReport?.lines || []).map((row) => {
    const translation = LINE_LABELS[row.code];
    return translation ? { ...row, name: translation[lang] } : row;
  });
  const currentMetrics = parseValidationMetrics(currentReport?.note);
  const previousMetrics = parseValidationMetrics(previousReport?.note);

  const buckets = {
    OPERATING: { cash: [], nonCash: [] },
    INVESTING: { cash: [], nonCash: [] },
    FINANCING: { cash: [], nonCash: [] },
    UNCLASSIFIED: { cash: [], nonCash: [] }
  };

  combinedRows.forEach((row) => {
    const section = buckets[row.classification] || buckets.UNCLASSIFIED;
    if (row.nonCash) {
      section.nonCash.push(row);
    } else {
      section.cash.push(row);
    }
  });

  const sections = SECTION_CONFIG.map((config) => {
    const sectionRows = buckets[config.key];
    const cashGroup = buildGroup(`${config.key}-cash`, labels[config.cashTitleKey], sectionRows.cash);
    const nonCashGroup = buildGroup(`${config.key}-noncash`, labels[config.nonCashTitleKey], sectionRows.nonCash, 'summary');
    const summaryGroup = buildSummaryGroup(
      `${config.key}-summary`,
      labels[config.totalLabelKey],
      cashGroup.currentTotal,
      cashGroup.previousTotal
    );

    const groups = [];
    if (cashGroup.rows.length > 0) {
      groups.push(cashGroup);
    }
    if (nonCashGroup.rows.length > 0) {
      groups.push(nonCashGroup);
    }
    groups.push(summaryGroup);

    return {
      key: config.key.toLowerCase(),
      title: labels[config.titleKey],
      groups,
      totalLabel: labels[config.totalLabelKey],
      currentTotal: cashGroup.currentTotal,
      previousTotal: cashGroup.previousTotal
    };
  }).filter((section) => section.groups.some((group) => group.rows.length > 0 || Math.abs(group.currentTotal) > 0.0001 || Math.abs(group.previousTotal) > 0.0001));

  return {
    labels,
    locale,
    currentPeriodLabel: currentPeriodLabel || labels.currentPeriod,
    previousPeriodLabel: previousPeriodLabel || labels.previousPeriod,
    comparativeAvailable: Boolean(previousReport?.lines?.length),
    metadataNote: labels.basisNote,
    sections,
    footerRows: [
      {
        label: labels.netChange,
        current: currentMetrics.netCashFlow,
        previous: previousMetrics.netCashFlow,
        variant: 'summary-strong'
      },
      {
        label: labels.openingCash,
        current: currentMetrics.openingCash,
        previous: previousMetrics.openingCash,
        variant: 'summary'
      },
      {
        label: labels.closingCash,
        current: currentMetrics.closingCash,
        previous: previousMetrics.closingCash,
        variant: 'total'
      }
    ]
  };
}
